export function parseApiError(err, fallback = "No pudimos completar la operación.") {
  if (err && err.response && err.response.data) {
    const data = err.response.data;
    if (typeof data.error === "string" && data.error.trim()) return data.error;
    if (typeof data.message === "string" && data.message.trim()) return data.message;
    if (Array.isArray(data.errors) && data.errors.length) return data.errors.join(", ");
    if (typeof data.errors === "string" && data.errors.trim()) return data.errors;
  }
  if (err && typeof err.message === "string" && err.message.trim()) return err.message;
  return fallback;
}
